import {
  FilterMode,
  CreditPurchaseCreateMutationVariables,
  CreditPurchase_OrderBy,
  CreditPurchase,
  SortOrder,
  CreditPurchase_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const creditPurchaseService = {
  createOne: buildCreateOne(
    (creditPurchaseCreateVariables: CreditPurchaseCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.creditPurchaseCreate(
          creditPurchaseCreateVariables
        );
        return result.creditPurchaseCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.creditPurchaseOne({ id });
    return result.creditPurchaseOne as CreditPurchase;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: CreditPurchase_OrderBy[] | null = null,
    filter: CreditPurchase_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: CreditPurchase_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.creditPurchaseListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.creditPurchaseListWithOffset
    ) as CreditPurchase[];
    return { list, orderBy };
  },
};
